import { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'
import { Base, StoreIcon } from '@itsrever/design-system'
import { useAppSelector } from '@/redux/hooks'
import {
  useSelectEcommerce,
  useSelectedEcommerceIds,
  useStoreGroups
} from '@/hooks'

// Pages that save to one store render this in the group view, so nothing reads or writes a store
// nobody picked. Each button picks one of the group's stores in the navbar. A page that only
// works for some of them passes those in `stores`.
export const StoreOnly = ({
  children,
  stores
}: {
  children: ReactNode
  stores?: string[]
}) => {
  const { t } = useTranslation()
  const selectedEcommerce = useAppSelector(
    (s) => s.generalData.selectedEcommerce
  )
  const groups = useStoreGroups()
  // A merchant with one group is in its group view with nothing picked.
  const selectedIds = useSelectedEcommerceIds()
  const groupStores =
    stores ??
    selectedIds ??
    (groups.length === 1 ? groups[0].ecommerces : undefined)
  const selectEcommerce = useSelectEcommerce()

  if (selectedEcommerce) return <>{children}</>
  return (
    <div className="flex justify-center px-8 py-16">
      <Base.EmptyState
        variant="card"
        className="max-w-md"
        icon={<StoreIcon />}
        title={t('selector_component.store_only_title')}
        description={t('selector_component.store_only_description')}
        actions={
          groupStores?.length
            ? groupStores.map((store) => (
                <Base.Button
                  key={store}
                  type="button"
                  variant="secondary"
                  size="sm"
                  onClick={() => selectEcommerce(store)}
                >
                  {store}
                </Base.Button>
              ))
            : undefined
        }
      />
    </div>
  )
}
